import { useCallback, useEffect, useState } from "react";

import { useOutletApi } from "@/features/authentication";

/**
 * The Ambil menu. The backend owns the source registry, so the menu is read
 * from it rather than mirrored in a frontend config — a second source type
 * shows up here with no change on this side.
 */
export const usePaymentSourceTypes = (outletId) => {
  const outletApi = useOutletApi(outletId);
  const [sourceTypes, setSourceTypes] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadSourceTypes = useCallback(async () => {
    if (!outletId) return;

    setLoading(true);
    try {
      const {
        data: { data },
      } = await outletApi.get("other-payment-sources");
      setSourceTypes(data || []);
    } catch {
      // The registry is optional garnish on this form: without it the user can
      // still hand-type every line, so a failure hides the button silently.
      setSourceTypes([]);
    } finally {
      setLoading(false);
    }
  }, [outletApi, outletId]);

  useEffect(() => {
    loadSourceTypes();
  }, [loadSourceTypes]);

  return { sourceTypes, loading };
};
